import { render, staticRenderFns } from "./remark-model.vue?vue&type=template&id=2af28082&"
import script from "./remark-model.vue?vue&type=script&lang=js&"
export * from "./remark-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports